import { call, put, takeEvery } from "redux-saga/effects";
import { getDocs, collection } from "firebase/firestore";
import { db } from "helpers/firebase/firebaseConfig";
import {
  FETCH_SETTLEMENTS_REQUEST,
} from "./actionTypes";
import {
  fetchSettlementsSuccess,
  fetchSettlementsFailure,
} from "./actions";

// Helper function to fetch settlements from Firestore
async function fetchSettlementsFromDB() {
  try {
    const querySnapshot = await getDocs(collection(db, "customer_settlements"));
    const settlements = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Sort by creation date (newest first)
    settlements.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    return settlements;
  } catch (error) {
    console.error("Error fetching settlements:", error);
    throw error;
  }
}

function* fetchSettlementsSaga() {
  try {
    const settlements = yield call(fetchSettlementsFromDB);
    yield put(fetchSettlementsSuccess(settlements));
  } catch (error) {
    yield put(fetchSettlementsFailure(error.message || "Failed to fetch settlements"));
  }
}

export default function* settlementSaga() {
  yield takeEvery(FETCH_SETTLEMENTS_REQUEST, fetchSettlementsSaga);
}
